// utils/formatRelativeDate.js

export const formatRelativeDate = (value) => {
  if (!value) return "—";

  const now = new Date();
  const target = new Date(value);

  const diffMs = target.getTime() - now.getTime();
  const isFuture = diffMs > 0;

  const diffDays = Math.round(Math.abs(diffMs) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return isFuture ? "today" : "today";
  }

  return isFuture ? `in ${diffDays} day${diffDays === 1 ? "" : "s"}` : `${diffDays} day${diffDays === 1 ? "" : "s"} ago`;
};